import { CommonFactEventMessage } from "../../types";
import { DiffView } from "@bagel-web/components";
import { MessageComponent, MessageComponentProps } from "./Message";

const FactEventMessage: MessageComponent<CommonFactEventMessage> = ({
  message,
  relatedMessages,
  displaySettings,
}: MessageComponentProps<CommonFactEventMessage>) => {
  return (
    <>
      <h6>
        Fact <code>{message.fact_name}</code>
      </h6>
      {displaySettings?.showFactDiffs && relatedMessages?.[0] ? (
        <DiffView
          oldValue={
            relatedMessages[0].content
              ? relatedMessages[0].content
              : message.content
          }
          newValue={message.content}
          showDiffOnly={
            displaySettings.hideUnchagedFactLines &&
            relatedMessages[0]?.content !== message.content
          }
        />
      ) : (
        <p
          style={{
            fontFamily: "monospace",
            fontSize: ".875em",
          }}
        >
          {message.content}
        </p>
      )}
    </>
  );
};

export default FactEventMessage;
